<template>
  <div class="auth-container">
    <header-auth />

    <slot />

    <illustration v-if="ilustrationImage" class="illustration">
      <img :src="ilustrationImage" alt="illustration" class="mb-n1"/>
    </illustration>

    <error-alert
      v-if="error.error"
      :error="error.error"
      :total-errors="error.totalErrors"
    />

    <success-alert
      v-if="success.success"
      :success="success.success"
      :total-success="success.totalSuccess"
    />
  </div>
</template>

<script lang="ts" setup>
import signInImage from '@/assets/login-illustration.svg'
import signUpImage from '@/assets/signup-illustration.svg'
import confirmEmailImage from '@/assets/confirm-email-illustration.svg'

const route = useRoute()

const illustrations = computed(() => ({
  signin: signInImage,
  signup: signUpImage,
  'confirm-account': confirmEmailImage,
  'forgot-password': signUpImage,
  'workspace-create': signInImage
}))

const ilustrationImage = computed(
  () => illustrations.value[route.name as keyof typeof illustrations.value]
)

const error = computed(() => ({
  error: errorStore().getLatesError,
  totalErrors: errorStore().totalErrors
}))

const success = computed(() => ({
  success: successStore().getLatestSuccess,
  totalSuccess: successStore().totalSuccess
}))
</script>

<style lang="scss" scoped>
.auth-container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.illustration {
  display: flex;
  align-items: flex-end;
  @media screen and (max-width: 768px) {
    display: none;
  }
}
</style>
